<template>
  <div style="padding:0 24px 0 24px" class="big">
    <div class="searchbox">
      <div class="item">
        <span>用户昵称</span>
        <el-input
          placeholder="请输入"
          v-model="nick_name"
          style="width:120px;margin-left:10px"
          @input="search"
          clearable
        ></el-input>
      </div>
      <div class="item">
        <span>交易流水号</span>
        <el-input
          placeholder="请输入"
          v-model="trade_no"
          style="width:120px;margin-left:10px"
          @input="search"
          clearable
        ></el-input>
      </div>
      <div class="item">
        <span>收货人</span>
        <el-input
          placeholder="请输入"
          v-model="consignee_name"
          style="width:120px;margin-left:10px"
          clearable
          @input="search"
        ></el-input>
      </div>

      <div class="item">
        <span>手机号</span>
        <el-input
          placeholder="请输入"
          v-model="consignee_phone"
          style="width:140px;margin-left:12px"
          clearable
          @input="search"
        ></el-input>
      </div>
      <div class="item">
        <span style="margin-right:10px">核对结果</span>
        <el-radio-group v-model="examine_status" @change="search">
          <el-radio :label="0">全部</el-radio>
          <el-radio :label="1">已通过</el-radio>
          <el-radio :label="2">已驳回</el-radio>
        </el-radio-group>
        <el-button
          type="info"
          style="background-color:#eceff2;;color:#747981;margin-left:10px"
          size="medium"
          @click="search"
        >查询</el-button>
      </div>
    </div>

    <div style="border: solid 1px #c9cbd6;">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%;min-width:1000px"
        :header-cell-style="{background:'#F5F5F5'}"
        @selection-change="handleSelectionChange"
      >
        <el-table-column label="生成时间" prop="create_time"></el-table-column>
        <el-table-column label="用户昵称" prop="nick_name"></el-table-column>
        <el-table-column label="处方总金额" prop="total_price"></el-table-column>
        <el-table-column label="处方数量" prop="total_num"></el-table-column>
        <el-table-column label="交易流水号" prop="trade_no"></el-table-column>
        <el-table-column label="转账备注" prop="remark"></el-table-column>
        <el-table-column label="收货人" prop="consignee_name"></el-table-column>
        <el-table-column label="手机号" prop="consignee_phone"></el-table-column>
        <el-table-column label="所在地区" prop="remark">
          <template slot-scope="scope">
            <div>
              <span>{{scope.row.address_info.province_name}}</span>
              <span>{{scope.row.address_info.city_name}}</span>
              <span>{{scope.row.address_info.district_name}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="核对结果" prop="remark">
          <template slot-scope="scope">
            <span v-if="scope.row.status==3">已通过</span>
            <span v-if="scope.row.status==4">已驳回</span>
            <span v-if="scope.row.status==10">已作废</span>
          </template>
        </el-table-column>
        <el-table-column label="驳回原因" prop="refund_desc"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="toDetail(scope.row.accounts_id)">查看处方</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top:24px">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import platform from "../../../api/platform";
import yewu from "../../../api/yewu";
import dayjs from "dayjs";
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      nick_name: "",
      trade_no: "",
      consignee_name: "",
      consignee_phone: "",
      examine_status: 0
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取处方列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        status: 3,
        nick_name: this.nick_name,
        trade_no: this.trade_no,
        consignee_name: this.consignee_name,
        consignee_phone: this.consignee_phone,
        examine_status: this.examine_status
      };

      this.axios
        .post("platform/prescription/getPrescriptionAccountsList", data)
        .then(res => {
          if (res.code == 0) {
            this.tableData = res.data.list.map(item => {
              item.create_time = platform.timestampToTime(item.create_time);
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    //多选
    handleSelectionChange(val) {
      this.selection = val;
    },
    //获取省市列表
    getProvince() {
      this.axios.post("platform/platform/getProvinceCityDistrict").then(res => {
        this.proList = res.data.list;
      });
    },
    //获取平台开方可以选择的剂型列表
    getDrugTypeList() {
      let platform_type = 3;
      this.axios
        .post("platform/photograph/getDrugTypeList", { platform_type })
        .then(res => {
          this.options2 = res.data.list;
        });
    },

    search() {
      this.currentPage = 1;
      this.getList();
    },

    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //查看详情
    toDetail(accounts_id) {
      this.$router.push({
        path: "accountsdetail",
        query: {
          accounts_id
        }
      });
    }
  },
  created() {
    this.getList();
    this.getProvince();
    this.getDrugTypeList();
  },
  activated() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.mydivider {
  margin: 0;
}

.btnbox {
  text-align: left;
  margin: 20px 0;
  padding-left: 14px;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 20px;
  .item {
    margin-right: 30px;
    margin-top: 24px;
  }
}
</style>
